// @ts-nocheck
import { Interaction } from "chart.js";

export default function (chart, e, options) {
  const items = [];
  let index;

  for (let datasetIndex = 0; datasetIndex < chart.data.datasets.length; datasetIndex++) {
    // check for interpolate setting
    // @ts-ignore
    if (!chart.data.datasets[datasetIndex].interpolate) {
      continue;
    }

    const meta: any = chart.getDatasetMeta(datasetIndex);
    // do not interpolate hidden charts
    if (meta.hidden) {
      continue;
    }

    const xScale = chart.scales[meta.xAxisID];
    const yScale = chart.scales[meta.yAxisID];

    const xValue = xScale.getValueForPixel(e.x as number) as number;

    if (xValue > xScale.max || xValue < xScale.min) {
      continue;
    }

    const data = chart.data.datasets[datasetIndex].data;

    index = data.findIndex(function (o: any) {
      return (o.x as number) >= xValue;
    });

    if (index === -1) {
      continue;
    }

    // linear interpolate value
    const prev: any = data[index - 1];
    const next: any = data[index];

    let interpolatedValue;

    if (prev && next) {
      const slope = (next.y - prev.y) / (next.x - prev.x);
      interpolatedValue = (prev.y as number) + (xValue - prev.x) * slope;
    }

    // @ts-ignore
    if (chart.data.datasets[datasetIndex].steppedLine && prev) {
      interpolatedValue = prev.y;
    }

    if (isNaN(interpolatedValue)) {
      continue;
    }

    const yPosition = yScale.getPixelForValue(interpolatedValue);

    // do not interpolate values outside the axis limits
    if (isNaN(yPosition)) {
      continue;
    }

    // create a 'fake' event point
    const fakePoint = {
      hasValue: function () {
        return true;
      },
      tooltipPosition: function () {
        return this._model;
      },
      _model: { x: e.x, y: yPosition },
      skip: false,
      stop: false,
      x: xValue,
      y: interpolatedValue,
    };

    items.push({ datasetIndex, element: fakePoint, index: 0 });
  }

  // add other, not interpolated, items
  const xItems = Interaction.modes.x(chart, e, options);
  for (index = 0; index < xItems.length; index++) {
    const item = xItems[index];
    // @ts-ignore
    if (!chart.data.datasets[item.datasetIndex].interpolate) {
      items.push(item);
    }
  }

  return items;
}
